import { useState, useContext, useMemo, useRef, useEffect } from 'react';
import moment from 'moment';

import { LoginContext } from '../context/login-context';

import useProtectedQuery from '../hooks/use-protected-query';
import useProtectedMutation from '../hooks/use-protected-mutation';

// import VOCClient from "../VOCClient";
import RebatesClient from '../RebatesClient';
import { queryOptions } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

export default function useFarm(props) {
    const { state: userData } = useContext(LoginContext);

    const {farmName} = props

    const {
        data: farm,
        isLoading: farmLoading,
        error: farmError,
        refetch: refetchFarm
    } = useProtectedQuery({
        queryKey: ['get_farm',],
        queryFn: async () => {
            let url = `/api/accounts/get-farm?farmName=${encodeURIComponent(farmName)}`;


            const result = await RebatesClient.standardFetch(url)

            if (result.response.ok) {
                return result.body
            }
            else {
                throw new Error("Error getting farm");
            }

        },
    });


    return {
        farm,
        farmLoading,
        farmError,
        refetchFarm,
    }
}
